<template>
  <a v-if="type === 'list'" href="javascript:void(0);" @click="showModal()">回访</a>

  <a-button v-else-if="type === 'detail'" type="primary" @click="showModal()">回访</a-button>

  <a-modal
    :confirmLoading="submitLoading"
    :centered="true"
    v-model:visible="visible"
    @ok="handleOk()"
    @cancel="handleCancel()"
  >
    <template #title>
      <h4 class="flow-model-title">工单回访</h4>
    </template>
    <a-form layout="vertical">
      <a-form-item label="回访方式" :required="true">
        <tenant-dict-select
          v-model:value="formRef.callBackType"
          code="ticket_call_back_type"
          placeholder="请选择回访方式"
        />
      </a-form-item>

      <a-form-item label="问题解决情况" :required="true">
        <tenant-dict-select
          v-model:value="formRef.problemResolutionStatus"
          code="ticket_problem_resolution_status"
          placeholder="请选择问题解决情况"
        />
      </a-form-item>

      <a-form-item label="维修费用(元)">
        <a-input-number
          v-model:value="formRef.repairCosts"
          :precision="2"
          :min="0"
          :max="999999999.99"
          placeholder="请输入维修费用"
          style="width: 100%"
        />
      </a-form-item>

      <a-form-item label="备注">
        <a-textarea
          v-model:value="formRef.remark"
          show-count
          placeholder="请输入备注"
          :rows="4"
          :maxlength="500"
        />
      </a-form-item>
    </a-form>
  </a-modal>
</template>

<script lang="ts">
import { message } from "ant-design-vue";
import { PropType, defineComponent, reactive, toRefs } from "vue";
import { TicketCallBackService } from "./service";

export default defineComponent({
  isGlobal: true,
  name: "TicketCallBackBtn",
  props: {
    type: {
      type: String,
      default: "list",
    },
    record: {
      type: Object as PropType<any>,
    },
    ticketType: {
      type: String,
      default: "bx",
    },
  },
  emits: ["refresh"],
  setup(props, { emit }) {
    const state = reactive(<
      {
        loading: boolean;
        visible: boolean;
      }
    >{
      loading: false,
      visible: false,
    });
    const formRef = reactive({
      callBackType: undefined as string | undefined,
      problemResolutionStatus: undefined as string | undefined,
      repairCosts: undefined as number | undefined,
      remark: "",
    });
    const { run: runAddCallBack, loading: submitLoading = false } =
      TicketCallBackService.useAddCallBack();
    const showModal = () => {
      state.visible = true;
    };
    const resetForm = () => {
      formRef.callBackType = undefined;
      formRef.problemResolutionStatus = undefined;
      formRef.repairCosts = undefined;
      formRef.remark = "";
    };
    const handleCancel = () => {
      resetForm();
    };
    const handleOk = async () => {
      if (!formRef.callBackType) {
        message.warn("回访方式不可为空");
        return;
      }
      if (!formRef.problemResolutionStatus) {
        message.warn("问题解决情况不可为空");
        return;
      }
      await runAddCallBack(props.record.id, {
        ticketId: props.record.id,
        callBackType: formRef.callBackType,
        problemResolutionStatus: formRef.problemResolutionStatus,
        repairCosts: formRef.repairCosts,
        remark: formRef.remark,
      });
      message.success("回访提交成功");
      emit("refresh");
      state.visible = false;
      resetForm();
    };

    return {
      ...toRefs(state),
      submitLoading,
      showModal,
      handleOk,
      handleCancel,
      formRef,
    };
  },
});
</script>
<style scoped>
.flow-model-title {
  margin-bottom: 0;
  font-weight: 600;
  display: inline-block;
}
</style>
